var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.7,197.3L128,113l84.3,84.3c10,10,26.2,10,36.2,0s10-26.2,0-36.2L146.1,58.7c-10-10-26.2-10-36.2,0L7.5,161.1 c-10,10-10,26.2,0,36.2C17.5,207.3,33.7,207.3,43.7,197.3L43.7,197.3z M102.4,76.8v358.4c0,14.1,11.5,25.6,25.6,25.6 c14.1,0,25.6-11.5,25.6-25.6V76.8c0-14.1-11.5-25.6-25.6-25.6C113.9,51.2,102.4,62.7,102.4,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3,314.7L384,399l-84.3-84.3c-10-10-26.2-10-36.2,0c-10,10-10,26.2,0,36.2l102.4,102.4c4.8,4.8,11.4,7.5,18.1,7.5 s13.3-2.7,18.1-7.5l102.4-102.4c10-10,10-26.2,0-36.2C494.5,304.7,478.3,304.7,468.3,314.7L468.3,314.7z M409.6,435.2V76.8 c0-14.1-11.5-25.6-25.6-25.6s-25.6,11.5-25.6,25.6v358.4c0,14.1,11.5,25.6,25.6,25.6S409.6,449.3,409.6,435.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsSortIcon);
export default __webpack_public_path__ + "static/media/arrows-sort-icon.adead8325c09a4427b3fc78cbd5ca2a0.svg";
export { ForwardRef as ReactComponent };